import { Requirements } from './strapi/requirements'

export type Option = {
  value: string
  requires: Requirements | null
  condition: string | null
  chain?: boolean
  key?: string
  noRecommendation?: boolean
  /**
   * If next step has a single rec with this flag we could treat it as auto step?
   * For consistency we should display it, but we could handle it like this
   */
  final?: boolean
  /**
   * If true OptionRecommendedModal will be shown for this recommendation option.
   */
  showRecommendedModal?: boolean
}

export type Item = {
  flows?: string[]
  name: string
  variable: string
  options: Option[]
}
